import React from 'react';
import { motion } from 'framer-motion';
interface ShimmerButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function ShimmerButton({
  children,
  onClick,
  className = '',
  ...rest
}: ShimmerButtonProps) {
  return <motion.button onClick={onClick} {...rest} animate={{
    scale: [1, 1.04, 1]
  }} transition={{
    duration: 1.8,
    repeat: Infinity,
    ease: 'easeInOut'
  }} whileHover={{
    scale: 1.07
  }} whileTap={{
    scale: 0.97
  }} className={`relative overflow-hidden bg-pistachio text-slate-dark font-bold py-4 px-8 rounded-full shadow-lg transition-shadow hover:shadow-xl shimmer-btn ${className} pt-[10px] pb-[10px]`} data-id="element-255">
      <span className="relative z-10" data-id="element-256">{children}</span>
    </motion.button>;
}